import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_grn_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    owner_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_comp_guid: fromDatatype.GuidDataFieldInterface;
    owner_branch_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    pic_01: fromDatatype.VarcharDatatypeInterface;
    pic_02: fromDatatype.VarcharDatatypeInterface;
    pic_03: fromDatatype.VarcharDatatypeInterface;
    sending_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    logistic_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    delivery_entity_json: fromDatatype.JsonDatatypeInterface;
    billing_json: fromDatatype.JsonDatatypeInterface;

}


export class bl_wms_grn_hdr_RowClass
    implements bl_wms_grn_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    owner_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    owner_comp_guid: fromDatatype.GuidDataFieldInterface;
    owner_branch_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    server_doc_1: fromDatatype.VarcharDatatypeInterface;
    client_doc_1: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    pic_01: fromDatatype.VarcharDatatypeInterface;
    pic_02: fromDatatype.VarcharDatatypeInterface;
    pic_03: fromDatatype.VarcharDatatypeInterface;
    sending_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    logistic_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    delivery_entity_json: fromDatatype.JsonDatatypeInterface;
    billing_json: fromDatatype.JsonDatatypeInterface;

}